import { useEffect, useReducer } from 'react';

export default function useFilters(
  shape: any,
  onApplyFilters?: (filters: any) => void,
  isToForceUpdateFilters?: boolean,
  newFiltersFromOutsideDialog?: any,
) {
  const [filters, setFilters] = useReducer((state: any, action: any) => ({ ...state, ...action }), shape);

  useEffect(() => {
    if (isToForceUpdateFilters && newFiltersFromOutsideDialog && onApplyFilters) {
      setFilters(newFiltersFromOutsideDialog);
      onApplyFilters({ ...filters, ...newFiltersFromOutsideDialog });
    }
  }, [isToForceUpdateFilters, onApplyFilters, filters, newFiltersFromOutsideDialog]);

  const toggle = (key: string) => (value: any) => {
    if (filters[key].includes(value)) {
      return filters[key].filter((item: any) => item !== value);
    }
    return [...filters[key], value];
  };

  const resetAllFilters = (shapeToReset: any = false) => {
    setFilters(shapeToReset || shape);
  };

  const updateSingleFilter = (key: string) => (value: string) => {
    // make sure we set filter as the new value passed in, if its not a string to toggle
    if (typeof value !== 'string') {
      setFilters({
        [key]: value,
      });
      return;
    }
    setFilters({
      [key]: Array.isArray(filters[key]) ? toggle(key)(value) : value,
    });
  };

  const updateSingleFilterWithoutToggle = (key: string) => (value: string) => {
    setFilters({
      [key]: value,
    });
  };

  const cleanSingleFilter = (key: string) => () => {
    setFilters({
      [key]: Array.isArray(filters[key]) ? [] : null,
    });
  };

  const selectAllFromSingleFilter = (key: string) => {
    setFilters({
      [key]: filters[key].includes('all') && filters[key].length === 1 ? [] : ['all'],
    });
  };

  return {
    filters,
    updater: updateSingleFilter,
    updaterWithoutToggle: updateSingleFilterWithoutToggle,
    cleaner: cleanSingleFilter,
    selectAll: selectAllFromSingleFilter,
    reset: resetAllFilters,
  };
}
